import * as React from "react";
import Dialog from "@mui/material/Dialog";
import { setMapDialogData } from "../../redux/actions/shared-actions";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { translateLine } from "../../services/shared";

/**
 * Dialog for clicked map elements - stops, vehicles, chargers etc.
 * @component
 * @category Components
 * @subcategory Map
 * @param {boolean} open  determines the dialog toggle
 * @param {function} onClose handler for toggling off the dialog
 */

const MapDialog = ({ open, onClose }) => {
  const dispatch = useDispatch();
  const { mapDialogData, websocketData, chargers, TMData, TBData, BData, subwayStations } = useSelector((state) => ({
    mapDialogData: state.shared.mapDialogData,
    websocketData: state.websocket,
    chargers: state.staticData.chargers,
    TMData: state.staticData.TMData,
    TBData: state.staticData.TBData,
    BData: state.staticData.BData,
    subwayStations: state.staticData.subwayStations,
  }));
  const { t, i18n } = useTranslation();
  const handleClose = () => {
    onClose();
    dispatch(setMapDialogData(null));
  };

  return (
    <>
      {mapDialogData ? (
        <Dialog fullWidth={true} maxWidth={"sm"} open={open} onClose={handleClose}>
          {mapDialogData.type === "bus" ? (
            <div className='map-dialog-container'>
              <img
                style={{ marginTop: "20px" }}
                src={process.env.PUBLIC_URL + `/icons/${mapDialogData.type}.webp`}
                alt=''
                width={"75"}
                height={"75"}
              />
              <span>
                {t("LINE")}: {translateLine(websocketData.avl.buses[mapDialogData.id].line)}
              </span>
              <br />
              <a
                className='map-dialog-link'
                href={`https://www.sofiatraffic.bg/${i18n.language}/transport/schedules`}
                target='_blank'
                rel='noopener noreferrer'>
                {t("CHECK_SCHEDULE")}
                <svg width='18px' height='18px' viewBox='0 0 24 24' style={{ cursor: "pointer" }}>
                  <g strokeWidth='2.1' stroke='#2c54a4' fill='none' strokeLinecap='round' strokeLinejoin='round'>
                    <polyline points='17 13.5 17 19.5 5 19.5 5 7.5 11 7.5'></polyline>
                    <path d='M14,4.5 L20,4.5 L20,10.5 M20,4.5 L11,13.5'></path>
                  </g>
                </svg>
              </a>
            </div>
          ) : null}
          {mapDialogData.type === "tram" ? (
            <div className='map-dialog-container'>
              <img
                style={{ marginTop: "20px" }}
                src={process.env.PUBLIC_URL + `/icons/${mapDialogData.type}.webp`}
                alt=''
                width={"75"}
                height={"75"}
              />
              <span>
                {t("LINE")}: {translateLine(websocketData.avl.trams[mapDialogData.id].line)}
              </span>
              <br />
              <a
                className='map-dialog-link'
                href={`https://www.sofiatraffic.bg/${i18n.language}/transport/schedules`}
                target='_blank'
                rel='noopener noreferrer'>
                {t("CHECK_SCHEDULE")}
                <svg width='18px' height='18px' viewBox='0 0 24 24' style={{ cursor: "pointer" }}>
                  <g strokeWidth='2.1' stroke='#2c54a4' fill='none' strokeLinecap='round' strokeLinejoin='round'>
                    <polyline points='17 13.5 17 19.5 5 19.5 5 7.5 11 7.5'></polyline>
                    <path d='M14,4.5 L20,4.5 L20,10.5 M20,4.5 L11,13.5'></path>
                  </g>
                </svg>
              </a>
            </div>
          ) : null}
          {mapDialogData.type === "trolley" ? (
            <div className='map-dialog-container'>
              <img
                style={{ marginTop: "20px" }}
                src={process.env.PUBLIC_URL + `/icons/${mapDialogData.type}.webp`}
                alt=''
                width={"75"}
                height={"75"}
              />
              <span>
                {t("LINE")}: {translateLine(websocketData.avl.trolleysAndEBuses[mapDialogData.id].line)}
              </span>
              <br />
              <a
                className='map-dialog-link'
                href={`https://www.sofiatraffic.bg/${i18n.language}/transport/schedules`}
                target='_blank'
                rel='noopener noreferrer'>
                {t("CHECK_SCHEDULE")}
                <svg width='18px' height='18px' viewBox='0 0 24 24' style={{ cursor: "pointer" }}>
                  <g strokeWidth='2.1' stroke='#2c54a4' fill='none' strokeLinecap='round' strokeLinejoin='round'>
                    <polyline points='17 13.5 17 19.5 5 19.5 5 7.5 11 7.5'></polyline>
                    <path d='M14,4.5 L20,4.5 L20,10.5 M20,4.5 L11,13.5'></path>
                  </g>
                </svg>
              </a>
            </div>
          ) : null}
          {mapDialogData.type === "bus-stop" ? (
            <div className='map-dialog-container'>
              <img
                src={process.env.PUBLIC_URL + `/icons/${mapDialogData.type}.webp`}
                alt=''
                width={"75"}
                height={"75"}
              />
              <br />
              {` ${Object.values(BData.filter((x) => x.line === mapDialogData.line)[0])
                .filter((x) => x.name === mapDialogData.direction)[0]
                .stops[mapDialogData.id].id.substring(1)}`}
              <br />
              <br />
              {/* <div className='info-box-row'>
                <span>{t("ROUTE")}:</span>
                <span>{mapDialogData.direction.toUpperCase()}</span>
              </div> */}
              <div className='info-box-row'>
                <span> {t("STOP")}:</span>
                <span>
                  {" "}
                  {` ${Object.values(BData.filter((x) => x.line === mapDialogData.line)[0])
                    .filter((x) => x.name === mapDialogData.direction)[0]
                    .stops[mapDialogData.id].name.toUpperCase()}`}
                </span>
              </div>
              <br />
              <a
                className='map-dialog-link'
                href={`https://www.sofiatraffic.bg/${i18n.language}/transport/schedules`}
                target='_blank'
                rel='noopener noreferrer'>
                {t("CHECK_SCHEDULE")}
                <svg width='18px' height='18px' viewBox='0 0 24 24' style={{ cursor: "pointer" }}>
                  <g strokeWidth='2.1' stroke='#2c54a4' fill='none' strokeLinecap='round' strokeLinejoin='round'>
                    <polyline points='17 13.5 17 19.5 5 19.5 5 7.5 11 7.5'></polyline>
                    <path d='M14,4.5 L20,4.5 L20,10.5 M20,4.5 L11,13.5'></path>
                  </g>
                </svg>
              </a>
            </div>
          ) : null}
          {mapDialogData.type === "tram-stop" ? (
            <div className='map-dialog-container'>
              <img
                src={process.env.PUBLIC_URL + `/icons/${mapDialogData.type}.webp`}
                alt=''
                width={"75"}
                height={"75"}
              />
              <br />
              {` ${Object.values(TMData.filter((x) => x.line === mapDialogData.line)[0])
                .filter((x) => x.name === mapDialogData.direction)[0]
                .stops[mapDialogData.id].id.substring(2)}`}
              <br />
              <br />
              {/* <div className='info-box-row'>
                <span>{t("ROUTE")}:</span>
                <span>{mapDialogData.direction.toUpperCase()}</span>
              </div> */}
              <div className='info-box-row'>
                <span> {t("STOP")}:</span>
                <span>
                  {" "}
                  {` ${Object.values(TMData.filter((x) => x.line === mapDialogData.line)[0])
                    .filter((x) => x.name === mapDialogData.direction)[0]
                    .stops[mapDialogData.id].name.toUpperCase()}`}
                </span>
              </div>
              <br />
              <a
                className='map-dialog-link'
                href={`https://www.sofiatraffic.bg/${i18n.language}/transport/schedules`}
                target='_blank'
                rel='noopener noreferrer'>
                {t("CHECK_SCHEDULE")}
                <svg width='18px' height='18px' viewBox='0 0 24 24' style={{ cursor: "pointer" }}>
                  <g strokeWidth='2.1' stroke='#2c54a4' fill='none' strokeLinecap='round' strokeLinejoin='round'>
                    <polyline points='17 13.5 17 19.5 5 19.5 5 7.5 11 7.5'></polyline>
                    <path d='M14,4.5 L20,4.5 L20,10.5 M20,4.5 L11,13.5'></path>
                  </g>
                </svg>
              </a>
            </div>
          ) : null}
          {mapDialogData.type === "trolley-stop" ? (
            <div className='map-dialog-container'>
              <img
                src={process.env.PUBLIC_URL + `/icons/${mapDialogData.type}.webp`}
                alt=''
                width={"75"}
                height={"75"}
              />
              <br />
              {` ${Object.values(TBData.filter((x) => x.line === mapDialogData.line)[0])
                .filter((x) => x.name === mapDialogData.direction)[0]
                .stops[mapDialogData.id].id.substring(
                  `${
                    Object.values(TBData.filter((x) => x.line === mapDialogData.line)[0]).filter(
                      (x) => x.name === mapDialogData.direction
                    )[0].stops[mapDialogData.id].id
                  }`.includes("TBE")
                    ? 3
                    : 2
                )}`}
              <br />
              <br />
              {/* <div className='info-box-row'>
                <span>{t("ROUTE")}:</span>
                <span>{mapDialogData.direction.toUpperCase()}</span>
              </div> */}
              <div className='info-box-row'>
                <span> {t("STOP")}:</span>
                <span>
                  {" "}
                  {` ${Object.values(TBData.filter((x) => x.line === mapDialogData.line)[0])
                    .filter((x) => x.name === mapDialogData.direction)[0]
                    .stops[mapDialogData.id].name.toUpperCase()}`}
                </span>
              </div>
              <br />
              <a
                className='map-dialog-link'
                href={`https://www.sofiatraffic.bg/${i18n.language}/transport/schedules`}
                target='_blank'
                rel='noopener noreferrer'>
                {t("CHECK_SCHEDULE")}
                <svg width='18px' height='18px' viewBox='0 0 24 24' style={{ cursor: "pointer" }}>
                  <g strokeWidth='2.1' stroke='#2c54a4' fill='none' strokeLinecap='round' strokeLinejoin='round'>
                    <polyline points='17 13.5 17 19.5 5 19.5 5 7.5 11 7.5'></polyline>
                    <path d='M14,4.5 L20,4.5 L20,10.5 M20,4.5 L11,13.5'></path>
                  </g>
                </svg>
              </a>
            </div>
          ) : null}
          {mapDialogData.type === "subway" ? (
            <div className='map-dialog-container'>
              <img
                src={process.env.PUBLIC_URL + `/icons/${mapDialogData.type}.webp`}
                alt=''
                width={"75"}
                height={"75"}
              />
              <br />
              <span>
                {t("SUBWAY_STATION")}: {subwayStations[mapDialogData.id].name}
              </span>
              <br />
              <a
                className='map-dialog-link'
                href='https://www.sofiatraffic.bg/en/transport/schedules-metro'
                target='_blank'
                rel='noopener noreferrer'>
                {t("CHECK_SCHEDULE")}
                <svg width='18px' height='18px' viewBox='0 0 24 24' style={{ cursor: "pointer" }}>
                  <g strokeWidth='2.1' stroke='#2c54a4' fill='none' strokeLinecap='round' strokeLinejoin='round'>
                    <polyline points='17 13.5 17 19.5 5 19.5 5 7.5 11 7.5'></polyline>
                    <path d='M14,4.5 L20,4.5 L20,10.5 M20,4.5 L11,13.5'></path>
                  </g>
                </svg>
              </a>
            </div>
          ) : null}
          {mapDialogData.type === "spark" ? (
            <div className='map-dialog-container'>
              <img
                style={{ marginTop: "20px" }}
                src={websocketData.spark[mapDialogData.id].photoUrl}
                alt=''
                width={"162"}
                height={"80"}
              />
              <span>Spark</span>
              <span> {websocketData.spark[mapDialogData.id].title}</span>
              <br />
              <div className='info-box-row'>
                <span>{t("PLATE_NUMBER")}:</span>
                <span>{websocketData.spark[mapDialogData.id].plateNumber}</span>
              </div>
              <div className='info-box-row'>
                <span>
                  {t("PRICE")}/{t("DAY")}:
                </span>
                <span>
                  {websocketData.spark[mapDialogData.id].dailyAmount} {t("CURRENCY_LETTERS")}
                </span>
              </div>
              <div className='info-box-row'>
                <span>{t("MINIMUM_LEASE")}:</span>
                <span>
                  {websocketData.spark[mapDialogData.id].minimumPrice} {t("CURRENCY_LETTERS")}
                </span>
              </div>
              <div className='info-box-row'>
                <span>
                  {t("PRICE")}/{t("MINUTE")}:
                </span>
                <span>
                  {websocketData.spark[mapDialogData.id].amount} {t("CURRENCY_LETTERS")}
                </span>
              </div>
              <div className='info-box-row'>
                <span>
                  {t("PRICE")}/{t("KM")}:
                </span>
                <span>
                  {websocketData.spark[mapDialogData.id].kilometerPrice.toFixed(2)} {t("CURRENCY_LETTERS")}
                </span>
              </div>
              <div className='info-box-row'>
                <span>{t("BATTERY")}:</span>
                <span>{websocketData.spark[mapDialogData.id].batteryPercentage}%</span>
              </div>
              {/* <div className='info-box-row'>
                <span>{t("ESTIMATED_DISTANCE")}:</span>
                <span>{websocketData.spark[mapDialogData.id].batteryEstimatedDistance}km</span>
              </div> */}
              <div className='info-box-row'>
                <span>{t("CHARGING")}:</span>
                <span>{websocketData.spark[mapDialogData.id].isCharging ? t("YES") : t("NO")}</span>
              </div>
              <br />
              <a
                className='map-dialog-link'
                href={i18n.language === "bg" ? "https://spark.bg/" : "https://spark.bg/en/"}
                target='_blank'
                rel='noopener noreferrer'>
                {t("VIEW_MORE")}
                <svg width='18px' height='18px' viewBox='0 0 24 24' style={{ cursor: "pointer" }}>
                  <g strokeWidth='2.1' stroke='#2c54a4' fill='none' strokeLinecap='round' strokeLinejoin='round'>
                    <polyline points='17 13.5 17 19.5 5 19.5 5 7.5 11 7.5'></polyline>
                    <path d='M14,4.5 L20,4.5 L20,10.5 M20,4.5 L11,13.5'></path>
                  </g>
                </svg>
              </a>
            </div>
          ) : null}
          {mapDialogData.type === "hobo" ? (
            <div className='map-dialog-container'>
              <img
                src={process.env.PUBLIC_URL + `/icons/${mapDialogData.type}.webp`}
                alt=''
                width={"75"}
                height={"75"}
              />
              <span>Hobo</span>
              <br />
              <div className='info-box-row'>
                <span>{t("BATTERY")}:</span>
                <span>{websocketData.hobo[mapDialogData.id].battery}%</span>
              </div>
              <div className='info-box-row'>
                <span>{t("UNLOCK_FEE")}:</span>
                <span>{`${(websocketData.hobo[mapDialogData.id].fixedPrice / 100).toFixed(2)} ${t(
                  "CURRENCY_LETTERS"
                )}`}</span>
              </div>
              <div className='info-box-row'>
                <span>
                  {t("PRICE")}/{t("MINUTE")}:
                </span>
                <span>{`${(websocketData.hobo[mapDialogData.id].rentalPrice / 100).toFixed(2)} ${t(
                  "CURRENCY_LETTERS"
                )}`}</span>
              </div>
              <br />
              <a
                className='map-dialog-link'
                href={i18n.language === "bg" ? "https://hobo.bg/" : "https://hobo.bg/en"}
                target='_blank'
                rel='noopener noreferrer'>
                {t("VIEW_MORE")}
                <svg width='18px' height='18px' viewBox='0 0 24 24' style={{ cursor: "pointer" }}>
                  <g strokeWidth='2.1' stroke='#2c54a4' fill='none' strokeLinecap='round' strokeLinejoin='round'>
                    <polyline points='17 13.5 17 19.5 5 19.5 5 7.5 11 7.5'></polyline>
                    <path d='M14,4.5 L20,4.5 L20,10.5 M20,4.5 L11,13.5'></path>
                  </g>
                </svg>
              </a>
            </div>
          ) : null}
          {mapDialogData.type === "charger" ? (
            <div className='map-dialog-container'>
              <img
                src={process.env.PUBLIC_URL + `/icons/${mapDialogData.type}.webp`}
                alt=''
                width={"75"}
                height={"75"}
              />
              <span> {chargers[mapDialogData.id].model}</span>
              <br />
              <div className='info-box-row'>
                <span>{t("STATION")}:</span>
                <span>{chargers[mapDialogData.id].stationName}</span>
              </div>
              <div className='info-box-row'>
                <span>
                  {t("PRICE")}/{t("KWH")}:
                </span>
                <span>
                  {chargers[mapDialogData.id].price.split("/ ")[0].split(" ")[1]} {t("CURRENCY_LETTERS")}
                </span>
              </div>
              <div className='info-box-row'>
                <span>{t("STARTING_FEE")}:</span>
                <span>
                  {chargers[mapDialogData.id].price.split("/ ")[1].split(" ")[1]} {t("CURRENCY_LETTERS")}
                </span>
              </div>
              <div className='info-box-row'>
                <span>{t("TYPE")}:</span>
                <span>{chargers[mapDialogData.id].type}</span>
              </div>
              <div className='info-box-row'>
                <span>{t("SOCKETS")}:</span>
                <span>{chargers[mapDialogData.id].sockets}</span>
              </div>
              <div className='info-box-row'>
                <span>{t("POWER")}:</span>
                <span>
                  {chargers[mapDialogData.id].capacity} {t("KW")}
                </span>
              </div>
            </div>
          ) : null}
          {mapDialogData.type === "greenCorridor" ? (
            <div className='map-dialog-container'>
              <img
                style={{ marginTop: "20px" }}
                src={process.env.PUBLIC_URL + `/icons/polygon.webp`}
                alt=''
                width={"75"}
                height={"75"}
              />
              <br />
              <span>{t(mapDialogData.id)}</span>
              <br />
              <span>{t("INTERSECTING_LINES")}:</span>
              <br />
              {mapDialogData.lines.map((line) => {
                return <span key={line}>{translateLine(line)}</span>;
              })}
            </div>
          ) : null}
          {mapDialogData.type === 1 || mapDialogData.type === 0 ? (
            <div className='map-dialog-container'>
              <img
                style={{ marginTop: "20px" }}
                src={
                  process.env.PUBLIC_URL +
                  `/icons/${mapDialogData.type === 0 ? "permanentOrganization.png" : "temporaryOrganization.webp"}`
                }
                alt=''
                width={"75"}
                height={"75"}
              />
              {/* kanachkova */}
              <div className='info-box-row'>
                <span>
                  <b>{t("REPAIRWORK_TYPE")}:</b>
                </span>
                <span>{t(mapDialogData.id)}</span>
              </div>
              <div className='info-box-row'>
                <span>
                  <b>{t("ADDRESS")}:</b>
                </span>
                <span>{t(mapDialogData.address)}</span>
              </div>
              <div className='info-box-row'>
                <span>
                  <b>{t("DESCRIPTION")}:</b>
                </span>
                <span className='reconstr-desc'>{t(mapDialogData.description)}</span>
              </div>
              {mapDialogData.period ? (
                <>
                  <div className='info-box-row'>
                    <span>
                      <b>{t("STARTS_AT")}:</b>
                    </span>
                    <span>{mapDialogData.period.start}</span>
                  </div>
                  <div className='info-box-row'>
                    <span>
                      <b>{t("ENDS_AT")}:</b>
                    </span>
                    <span>{mapDialogData.period.end}</span>
                  </div>
                </>
              ) : null}

              {mapDialogData.file ? (
                <a
                  style={{ marginTop: "20px" }}
                  className='map-dialog-link'
                  href={mapDialogData.file}
                  target='_blank'
                  rel='noopener noreferrer'>
                  {t("SITE_DETAILS")}
                  <svg width='18px' height='18px' viewBox='0 0 24 24' style={{ cursor: "pointer" }}>
                    <g strokeWidth='2.1' stroke='#2c54a4' fill='none' strokeLinecap='round' strokeLinejoin='round'>
                      <polyline points='17 13.5 17 19.5 5 19.5 5 7.5 11 7.5'></polyline>
                      <path d='M14,4.5 L20,4.5 L20,10.5 M20,4.5 L11,13.5'></path>
                    </g>
                  </svg>
                </a>
              ) : null}
              <br />
              <br />
            </div>
          ) : null}

          <button onClick={handleClose} className='close-button'>
            {t("CLOSE")}
          </button>
        </Dialog>
      ) : null}
    </>
  );
};
export default React.memo(MapDialog);
